import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: "[prevent-submit]"
})
export class PreventSubmitInputDirective {
  @HostListener("keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    const { key } = event;
    if (key === "Enter") {
      event.preventDefault();
    }
  }
}
